import { Components, Theme } from "@mui/material";

export default function Tabs(theme: Theme): Components["MuiTabs"] {
  return {
    defaultProps: { textColor: "secondary", indicatorColor: "secondary" },
  };
}
